import { render } from "./winningModal.vue?vue&type=template&id=28af98ac"
import script from "./winningModal.vue?vue&type=script&lang=js"
export * from "./winningModal.vue?vue&type=script&lang=js"
script.render = render

export default script